import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useRecoilState } from 'recoil';
import { roleAtom, subAtom } from 'core/config/atoms';

import { AnimatePresence, motion } from "framer-motion";

import { FileText, FilePieChart, NotepadText } from 'lucide-react';

import PanelDev from '../panels/dev/PanelDev';

import PanelOrder from 'panels/order/PanelOrder';
import PanelInvoice from 'panels/order/PanelInvoice';
import PanelBooking from 'panels/order/PanelBooking';

export default function LayoutOrder() {

    const [role] = useRecoilState(roleAtom);
    const [sub] = useRecoilState(subAtom);

    const itemVariants = {
        closed: { opacity: 0 },
        open: { opacity: 1 }
    };

    const { page } = useParams();

    const [isOpen, setIsOpen] = useState(true);

    const navigate = useNavigate();

    const changeNav = (link) => {
        navigate(`/${link}`);
        setIsOpen(true);
    }

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    }

    const closeMenu = () => {
        setIsOpen(false);
    }

    const openMenu = () => {
        setIsOpen(true);
    }

    return (
        <div className='w-full min-h-screen grid grid-cols-12 gap-2'>
            <AnimatePresence>
                {
                    isOpen && <motion.div initial={{ flexBasis: 0, opacity: 0 }} animate={{ flexBasis: '100%', opacity: 1 }} exit={{ flexBasis: 0, opacity: 0, transition: { delay: 0.2, duration: 0.3 } }} className="col-span-2 h-screen bg-slate-100">
                        <motion.h1 initial="closed" animate="open" exit="closed" variants={itemVariants} className="text-2xl font-medium px-1 mx-2 py-1 my-2 rounded">Orders</motion.h1>
                        <motion.ul initial="closed" animate="open" exit="closed" variants={itemVariants} className="w-full flex flex-col items-start space-y-2 px-2">
                            <li className={`w-full p-1 cursor-pointer text-base hover:bg-gray-200 rounded flex items-center ${page === 'invoices' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('invoices') }}>
                                <FileText size={20} className='mr-2' /> Invoice Tally
                            </li>
                            <li className={`w-full p-1 cursor-pointer text-base hover:bg-gray-200 rounded flex items-center ${page === 'order' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('order') }}>
                                <FilePieChart size={20} className='mr-2' /> Orders Tally
                            </li>
                            {
                                (sub.features.isRoom && role.modules.includes("BOOKING")) && <li className={`w-full p-1 cursor-pointer text-base hover:bg-gray-200 rounded flex items-center ${page === 'booking' ? 'text-prime font-medium' : 'text-black'}`} onClick={() => { changeNav('booking') }}>
                                    <NotepadText size={20} className='mr-2' /> Booking Tally
                                </li>
                            }
                        </motion.ul>
                    </motion.div>
                }
            </AnimatePresence>
            <div className={`h-screen ${isOpen ? "col-span-10" : "col-span-12"}`}>
                {
                    (() => {
                        switch (page) {
                            case 'order':
                                return (<PanelOrder onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'invoices':
                                return (<PanelInvoice onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            case 'booking':
                                return (<PanelBooking onToggle={toggleMenu} closeToggle={closeMenu} openToggle={openMenu} />);
                            default:
                                return (<PanelDev />);
                        }
                    })()
                }
            </div>
        </div>
    )
}
